import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDuration(totalSeconds: number): string {
  const m = Math.floor(totalSeconds / 60);
  const s = Math.floor(totalSeconds % 60);
  return `${m}:${s.toString().padStart(2, "0")}`;
}

export function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? "")
    .join("");
}

/**
 * Map a stored answer value (single like "yes" or multi like "a,b,c") back to
 * its human-readable option label(s). Works for all question types.
 */
export function answerLabels(
  options: { value: string; label: string }[] | null | undefined,
  answer: string | null | undefined,
): string | null {
  if (!answer) return null;
  const map = new Map((options ?? []).map((o) => [o.value, o.label]));
  const labels = answer
    .split(",")
    .map((v) => v.trim())
    .filter(Boolean)
    .map((v) => map.get(v) ?? v);
  return labels.length ? labels.join(", ") : null;
}

/** Cryptographically-strong url-safe token for candidate invite links. */
export function generateAccessToken(bytes = 32): string {
  const arr = new Uint8Array(bytes);
  crypto.getRandomValues(arr);
  return Array.from(arr, (b) => b.toString(16).padStart(2, "0")).join("");
}
